module.exports = __webpack_public_path__ + "static/media/plane-departure.90bc01d4.svg";